import { createRequest } from "helpers/tools";

export const sourceGoogleSheets = async (data) => {
    return await createRequest({
        suffix: `sources/google/auth-url`,
        handleError: true,
        method: "post",
        payload: data,
    });
};

export const googleSendCode = async (data) => {
    return await createRequest({
        suffix: `sources/google-sheets`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
export const googleSendSpreadSheetId = async (data, id) => {
    return await createRequest({
        suffix: `sources/google-sheets/${id}/pages`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
export const googleSpreadSheetCreate = async (
    selectedOptions,
    id,
    spreadsheetId,
    spreadsheetName,
) => {
    let names = null;
    if (Array.isArray(selectedOptions) && selectedOptions.length > 0) {
        names = selectedOptions?.map((option) => option?.name);
    } else {
        names = [];
    }
    let payload = {
        page_names: names,
        spreadsheet_id: spreadsheetId,
        spreadsheet_name: spreadsheetName,
    };
    return await createRequest({
        suffix: `sources/google-sheets/${id}/create`,
        method: "post",
        payload,
        handleError: false,
    });
};
